import { render, staticRenderFns } from "./SJJRBG.vue?vue&type=template&id=e5ab2740&scoped=true&"
import script from "./SJJRBG.vue?vue&type=script&lang=js&"
export * from "./SJJRBG.vue?vue&type=script&lang=js&"
import style0 from "./SJJRBG.vue?vue&type=style&index=0&id=e5ab2740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ab2740",
  null
  
)

export default component.exports